<template>
  <div
    class="checkbox"
    :class="{
      'checkbox--invalid': errorMessage
    }"
  >
    <div class="row">
      <input
        :id="id"
        class="input"
        type="checkbox"
        :name="name"
        :value="checkedValue"
        :checked="checked"
        @change="handleChange"
      />
      <label :for="id" class="label">
        <span class="box">
          <CheckIcon class="box__icon" />
        </span>
        <span class="label__text t-p-s-130">{{ label }}</span>
      </label>
    </div>
    <FormError :error-message="errorMessage" />
  </div>
</template>

<script setup lang="ts">
import { useField } from 'vee-validate'

import CheckIcon from '@/assets/icons/check.svg?component'

const props = defineProps<{
  label: string
  name: string
  checkedValue: boolean
}>()

const { name } = toRefs(props)

const { handleChange, checked, errorMessage } = useField(
  () => props.name,
  undefined,
  {
    type: 'checkbox',
    checkedValue: props.checkedValue
  }
)

const id = useId()
</script>

<style scoped lang="scss">
.checkbox {
  @include flex-col;
  position: relative;
  gap: rem(6px);
  margin-bottom: rem(18px);
}

.input {
  position: absolute;
  inset: 0;
  pointer-events: none;
  opacity: 0;
}

.label {
  display: flex;
  gap: rem(12px);
}

.box {
  @include center-content;
  @include size(18px);
  flex-shrink: 0;
  color: $global-white;
  border: 1px solid $global-grey-04;
  border-radius: 3px;

  transition:
    border-color $transition,
    background-color $transition,
    color $transition;

  &__icon {
    display: block;
    width: 100%;
    height: 100%;

    opacity: 0;
    transition: opacity $transition;
  }

  .checkbox--invalid & {
    border-color: $global-error;
  }

  .input:checked + .label & {
    background-color: $global-sun-02;
    border-color: $global-sun-02;

    &__icon {
      opacity: 1;
    }
  }
}
</style>
